import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Avatar, Dropdown } from 'antd';
import { Link } from 'react-router-dom';
import { NavigationContext } from '../side-menu/side-menu';
import { UserOutlined } from '@ant-design/icons';
import { updateLoginStatus } from './../../actions/admin-profile';
import { firebaseAuth } from './../../firebase/firebase';

export class Header extends Component {
  static contextType = NavigationContext;

  constructor() {
    super();
    this.state = {
      isDropdownActive: false
    }
  }

  signOut = () => {
    firebaseAuth.signOut().then((res) => {
      // console.log('Logout', res)
    }).catch((error) => console.log('Errr', error))
    localStorage.clear();
    this.props.updateLoginStatus();
    window.location.reload();

  }

  handleDropdownClick = (type, event) => {
    // console.log('Event',  type, event);
    this.setState({ isDropdownActive: event });
  }
  render() {
    const { isDropdownActive } = this.state;
    if (localStorage.getItem('auth_token'))
      return (
        <div className="slim-header with-sidebar">
          {/* <Script /> */}
          <div className="container-fluid ">
            <div className="slim-header-left">
              <h2 className="slim-logo"><Link to="/analytics" aria-label="ICOC home">ICOC</Link></h2>
              <button type="button" id="slimSidebarMenu" className="slim-sidebar-menu" aria-label="Toggle navigation" aria-controls="admin-navigation" aria-expanded={this.context.expanded} onClick={this.context.toggle}><span aria-hidden="true"></span></button>
              {/* <div className="search-box">
            <input type="text" className="form-control" placeholder="Search">
            <button className="btn btn-primary"><i className="fa fa-search"></i></button>
          </div> */}
            </div>
            <div className="slim-header-right">


              <Dropdown trigger={['click']} open={isDropdownActive} onOpenChange={open => this.handleDropdownClick('change', open)} placement="bottomRight" menu={{ items: [{ key: 'sign-out', label: 'Sign Out', icon: <i className="icon ion-forward" aria-hidden="true" /> }], onClick: this.signOut }}>
                <button type="button" className="logged-user" aria-label="Admin account menu" aria-haspopup="menu" aria-expanded={isDropdownActive}>
                  <Avatar icon={<UserOutlined />} style={{ background: '#e6f4ff', color: '#1677ff' }} />
                  <span>Admin</span>
                  <i className="fa fa-angle-down" aria-hidden="true"></i>
                </button>
              </Dropdown>
            </div>

          </div>
        </div>
      );
    else return null;
  }
}

export default connect(null, { updateLoginStatus })(Header);